
const initialState: any[] = [];

const feedbackReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case "SET_FEEDBACK":
      return action.payload; 
    default:
      return state;
  }
};

export default feedbackReducer;